var _path, _rect, _path2, _path3, _path4, _circle, _circle2, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoChats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 474,
    height: 339,
    viewBox: "0 0 474 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1888 315.657C-15.1213 291.536 46.4258 278.805 81.3631 275.455C208.453 273.323 431.69 255.609 460.516 297.494C467.346 307.419 455.213 317.865 443.42 320.333C340.314 341.91 57.1721 343.886 18.1888 315.657Z",
    fill: "#DCE9FD",
    stroke: "#DCE8FC",
    strokeWidth: 2.87156
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 81.8386,
    y: 64.6101,
    width: 304.385,
    height: 235.468,
    rx: 21.5367,
    fill: "#FEFFFE",
    stroke: "#1D66E4",
    strokeWidth: 8.61468
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M213.932 219.675C222.068 216.803 240.637 215.08 249.826 231.161",
    stroke: "#266EE5",
    strokeWidth: 5.74312,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M427.86 166.551V162.243H423.773L423.559 166.324L427.86 166.551ZM469.498 170.858C471.877 170.858 473.805 168.929 473.805 166.551C473.805 164.172 471.877 162.243 469.498 162.243V170.858ZM387.989 228.276C402.753 227.141 429.759 212.418 432.161 166.777L423.559 166.324C421.366 207.978 397.45 218.908 387.328 219.687L387.989 228.276ZM427.86 170.858H469.498V162.243H427.86V170.858Z",
    fill: "#1B65E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1702 219.687C84.5421 219.87 86.3169 221.94 86.1345 224.312C85.952 226.684 83.8814 228.459 81.5095 228.276L82.1702 219.687ZM41.638 166.551V162.243H45.7246L45.9394 166.324L41.638 166.551ZM81.5095 228.276C66.745 227.141 39.7388 212.418 37.3366 166.777L45.9394 166.324C48.1317 207.978 72.0478 218.908 82.1702 219.687L81.5095 228.276ZM41.638 170.858H0.000387788V162.243H41.638V170.858Z",
    fill: "#1B65E3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 186.651,
    cy: 183.78,
    r: 8.61468,
    transform: "rotate(180 186.651 183.78)",
    fill: "#1D66E5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 284.284,
    cy: 183.78,
    r: 8.61468,
    transform: "rotate(180 284.284 183.78)",
    fill: "#1E67E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9942 73.2251C55.5156 62.696 60.0144 41.6379 81.8382 41.6379",
    stroke: "#266EE5",
    strokeWidth: 5.74312,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4125 72.2379C35.4211 59.1543 37.7931 31.5585 71.2127 25.8443",
    stroke: "#266EE5",
    strokeWidth: 5.74312,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M290.027 295.771C352.132 280.839 351.601 168.465 343.151 123.477H381.917V275.67C381.917 286.771 372.918 295.771 361.816 295.771H290.027Z",
    fill: "#F1F6FC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.375 64.6101H364.687C376.582 64.6101 386.224 74.2524 386.224 86.1468V119.17H81.8386V86.1468C81.8386 74.2524 91.4809 64.6101 103.375 64.6101Z",
    fill: "#B4D1FF",
    stroke: "#1D66E4",
    strokeWidth: 8.61468
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M418.412 108.051H394.961L368.872 125.405C365.002 127.984 359.785 125.229 359.785 120.539V108.051C342.196 108.051 330.471 96.3257 330.471 78.7374V43.5604C330.471 25.9721 342.196 14.2466 359.785 14.2466H418.412C436.001 14.2466 447.726 25.9721 447.726 43.5604V78.7374C447.726 96.3257 436.001 108.051 418.412 108.051Z",
    fill: "white",
    stroke: "#1B65E3",
    strokeWidth: 8.79415,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M389.097 66.6005V65.3695C389.097 61.3828 391.56 59.2721 394.022 57.5719C396.426 55.9304 398.829 53.8198 398.829 49.9504C398.829 44.5567 394.491 40.218 389.097 40.218C383.704 40.218 379.365 44.5567 379.365 49.9504",
    stroke: "#78A6EF",
    strokeWidth: 8.79415,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M389.069 80.613H389.122",
    stroke: "#78A6EF",
    strokeWidth: 8.79415,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChats);
export default __webpack_public_path__ + "static/media/noChats.98590709c3866b3c003ceb315ad63152.svg";
export { ForwardRef as ReactComponent };